import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask } from "../Components/Items";

moment.locale("es");

const reporteDePagosProveedoresPdf = (values) => {
  const empresa = values.empresa;
  const logoBiwo = values.logoBiwo;

  /* ================= TABLA DE PAGOS ================= */
  let pagos = [];

  for (const valuePago of values.pagos) {
    pagos.push([
      { text: valuePago.proveedor, style: "textoTabla", alignment: "left" },
      { text: valuePago.factura, style: "textoTabla", alignment: "left" },
      { text: valuePago.fechaPago, style: "textoTabla", alignment: "center" },
      { text: valuePago.banco, style: "textoTabla", alignment: "left" },
      { text: valuePago.moneda, style: "textoTabla", alignment: "center" },
      {
        text: dineroDisabledMask(valuePago.monto),
        style: "textoTabla",
        alignment: "right",
      },
      { text: valuePago.referencia || "", style: "textoTabla", alignment: "left" },
    ]);
  }

  const totalMonto = values.pagos.reduce(
    (acc, val) => acc + Number(val.monto || 0),
    0
  );

  pagos.push([
    { text: "TOTAL:", style: "tituloTabla", colSpan: 5, alignment: "right" },
    {},
    {},
    {},
    {},
    {
      text: dineroDisabledMask(totalMonto),
      style: "tituloTabla",
      alignment: "right",
    },
    { text: "", style: "tituloTabla" },
  ]);

  /* ================= DOCUMENT DEFINITION ================= */
  const dd = {
    footer: {
      image: "logoBiwo",
      alignment: "center",
      width: 80,
    },

    content: [
      {
        margin: [0, 0, 0, 0],
        table: {
          widths: ["18%", "52%", "30%"],
          body: [
            [
              {
                image: "logo",
                fit: [80, 80],
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
              },
              {
                margin: [0, 0, 0, 0],
                table: {
                  widths: ["100%"],
                  body: [
                    [
                      {
                        text: empresa.nombreComercial
                          ? empresa.nombreComercial
                          : empresa.persona
                          ? empresa.nombre
                          : `${empresa.nombre} ${empresa.apellidoPaterno} ${empresa.apellidoMaterno}`,
                        style: "tableHeader",
                      },
                    ],
                    [
                      {
                        text: `R.F.C: ${empresa.rfc}`,
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text: `${empresa.calle} ${empresa.numeroCalle} ${
                          empresa.numeroInterior || ""
                        }`,
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text: `${empresa.colonia.tipoAsentamiento} ${
                          empresa.colonia.nombre
                        } C.P. ${empresa.colonia.cp} ${
                          empresa.municipio.nombre
                        } ${empresa.estado.abreviatura} ${
                          empresa.pais.abreviatura
                        }`,
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text: "REPORTE DE PAGOS A PROVEEDORES",
                        style: "tableHeader",
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              },
              {
                margin: [0, 0, 0, 0],
                table: {
                  widths: ["100%"],
                  body: [
                    [
                      {
                        text: "Fecha Inicial:",
                        style: "subheader",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text: moment(values.fechaInicial).locale("es").format("LL"),
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text: "Fecha Final:",
                        style: "subheader",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text: moment(values.fechaFinal).locale("es").format("LL"),
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text: "Fecha de Impresión:",
                        style: "subheader",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text: moment().locale("es").format("LL"),
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              },
            ],
          ],
        },
        layout: {
          defaultBorder: false,
          paddingLeft: () => 0,
          paddingRight: () => 0,
          paddingTop: () => 0,
          paddingBottom: () => 0,
        },
      },


      /* ===== TABLA PRINCIPAL ===== */
      {
        style: "tableExample",
        table: {
          widths: ["18%", "14%", "10%", "14%", "8%", "12%", "24%"],
          body: [
            [
              { text: "Proveedor", style: "tituloTabla" },
              { text: "Factura", style: "tituloTabla" },
              { text: "Fecha", style: "tituloTabla" },
              { text: "Banco", style: "tituloTabla" },
              { text: "Moneda", style: "tituloTabla" },
              { text: "Monto", style: "tituloTabla" },
              { text: "Referencia", style: "tituloTabla" },
            ],
            ...pagos,
          ],
        },
        layout: {
          fillColor: (rowIndex) =>
            rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff",
        },
      },
    ],

    images: {
      logo: empresa.logo.base64Completa,
      logoBiwo: logoBiwo.base64Completa,
    },

    styles: {
      tableHeader: {
        bold: true,
        fontSize: 12,
        alignment: "center",
      },
      subheader: {
        fontSize: 8,
        bold: true,
      },
      textoChico: {
        fontSize: 8,
      },
      tituloTabla: {
        fontSize: 8,
        bold: true,
        fillColor: "#cccccc",
        alignment: "center",
      },
      textoTabla: {
        fontSize: 8,
      },
      tableExample: {
        margin: [0, 5, 0, 5],
      },
    },

    pageSize: "LETTER",
    pageMargins: [20, 20, 20, 60],
  };

  return dd;
};

export default reporteDePagosProveedoresPdf;
